// @flow
import React, { Fragment } from 'react';
import { isEmpty } from 'lodash';

import { COLORS } from 'Components/utils/color/colors';
import { heights } from 'Components/widgets/navigation/Navigation.constants';
import { ICONS } from 'Components/utils/icon/icons';

import { Badge, type BadgeProps } from 'Components/frameworks/badge/Badge.jsx';
import { Title } from 'Components/frameworks/title/Title.jsx';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { ImmersiveSlideShow } from 'Components/widgets/immersive-slideshow/ImmersiveSlideShow.jsx';

type Props = {
  badgeIcon?: BadgeProps,
  hasInsetBorder?: boolean,
  infos: Array<string>,
  media: Array<string>,
  nextLabel?: string,
  previousLabel?: string,
  size: ImmersiveSizeProps,
  title: string,
};

export function ProductImmersiveNarrow(props: Props) {
  const {
    badgeIcon = {},
    hasInsetBorder,
    infos,
    media,
    nextLabel,
    previousLabel,
    size,
    title,
  } = props;
  const isExclusiveCollection = hasInsetBorder;

  const icon = badgeIcon.iconName ? badgeIcon.iconName : '';
  const iconName = icon === ICONS.TRIDENT45 ? ICONS.TRIDENT4 : icon;

  return (
    <Fragment>
      <div
        className="fadeInLong bg-white flex items-center p-1 py-2 w-full z-2"
        style={{ marginTop: heights.NAVIGATION_NARROW_HEIGHT }}
      >
        {!isExclusiveCollection ||
        (icon === ICONS.TRIDENT45 || icon === ICONS.TRIDENT6 || icon === ICONS.CRUISE) ? (
          <Badge
            {...badgeIcon}
            iconName={iconName}
            iconSize=""
            className="mx-1 rounded-tiny"
            size={27}
          />
        ) : null}
        {(isExclusiveCollection || icon === ICONS.TRIDENT45) && icon !== ICONS.CRUISE ? (
          <div
            style={{ height: '27px' }}
            className="bg-deepBlue px-2 flex items-center rtl:mr-2 inset-border-after--small"
          >
            <Icon
              name={ICONS.EXCLUSIVE_COLLECTION}
              width="calc(38rem / 16)"
              color={COLORS.WHITE}
              isNotSquare
            />
          </div>
        ) : null}
        <div className="mx-1 flex-1">
          <Title
            color={COLORS.GRAY_DARKER}
            className="font-brand leading-one text-md w-full"
            hLevel={1}
            theme="none"
          >
            {title}
          </Title>
          {!isEmpty(infos) && (
            <div className="flex">
              <div
                className="rtl:mr-1 font-brand uppercase leading-one text-sm text-gray-dark"
                data-testid="ProductImmersiveNarrow-info"
              >
                {infos[0]}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="relative">
        <ImmersiveSlideShow
          media={media}
          hasInsetBorder={hasInsetBorder}
          immersiveSize={size}
          nextLabel={nextLabel}
          previousLabel={previousLabel}
        />
      </div>
    </Fragment>
  );
}
